import { gql } from "@apollo/client";

export const userQuery = gql`  
  query {
    user {
      first_name
      last_name
    }
  }
`;
